module.exports = __webpack_public_path__ + "static/media/IMG_2666.47cf80ee.JPG";